import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { GoogleAnalyticsService } from 'src/app/core/services/google-tag-manager.service';
import { GTMOnboardingEvents, OnboardingSteps } from 'src/app/model/google-tag-manager/api-status';

@Component({
  selector: 'app-success-screen',
  templateUrl: './success-screen.component.html',
  styleUrls: ['./success-screen.component.scss']
})
export class SuccessScreenComponent implements OnInit {
  @Output() changeHeading = new EventEmitter();

  constructor(
    private router: Router,
    private googleAnalyticsService: GoogleAnalyticsService
  ) { }

  ngOnInit(): void {
    this.changeHeading.emit();
    this.googleAnalyticsService.emitOnboardingEvent(GTMOnboardingEvents.Complete, OnboardingSteps.Success);
  }

  navigateToLogin() {
    window.location.replace('/login');
  }

  // login controls not loading to close button is handled here
  onClose() {
    this.router.navigate(['/login'], { queryParamsHandling: 'preserve' }).then(
      () => { window.location.reload(); });
  }
}
